__turbopack_context__.v({
  "fingers": "fingers-module-scss-module__h178la__fingers",
  "fingersIcon": "fingers-module-scss-module__h178la__fingersIcon",
});
